<script setup lang="ts">
import BadgeItem from '@/common/components/molecules/badge/BadgeItem.vue';
import PopupListElement from '../popupListElement/PopupListElement.vue';
import { type Props, type Emit, setup } from './dashboardElement.setup';

const props = defineProps<Props>();
const emit = defineEmits<Emit>();

const {
  isCurrentPath,
  itemLength,

  onHover,
  onClick,
} = setup(props, emit);
</script>

<template>
  <popup-list-element
    :selected="isCurrentPath"
    :class="['floating-menu-element', { clicked: props.clicked }]"
    @hover="onHover"
    @click="onClick"
  >
    <template #left-side>
      <span>{{ props.dashboardMenu.text }}</span>
      <badge-item
        size="xsmall"
        :class="['dashboard-length-badge']"
      >
        <span>
          {{ itemLength }}
        </span>
      </badge-item>
    </template>
    <template #default>
      <ev-icon
        icon="icon-arrow-right"
        class="floating-menu-element__chevron"
      />
    </template>
  </popup-list-element>
</template>

<style scoped lang="scss">
.dashboard-length-badge {
  justify-content: center;
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 4px;
  background-color: var(--color-blue-05-05);
  color: var(--color-gray-00-00);

  &:hover {
    background-color: var(--color-blue-05-05) !important;
  }
}
</style>
